import React from "react";
import classes from "./SectorsGrid.module.scss";

const SectorCard = ({ image, title, text, smallCards }) => {
  return (
    <div
      className={`${classes["sector-card"]} ${smallCards && classes["sector-card--sm"]}`}
    >
      <div className={classes["sector-card__image-container"]}>
        <img
          src={image}
          alt={title}
          className={classes["sector-card__image"]}
        />
      </div>
      <div className={classes["sector-card__text"]}>
        <h3 className={classes["sector-card__text--title"]}>{title}</h3>
        <p className={classes["sector-card__text--body"]}>{text}</p>
      </div>
    </div>
  );
};

export default SectorCard;
